window.showCustomToast = function (message, type = 'success') {
  const Toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    icon: type
  })

  Toast.fire({
    title: message
  })
}

window.deleteItem = function (deleteRoute, redirectRoute) {
  Swal.fire({
    title: 'Está seguro?',
    text: 'Esta acción es irreversible!',
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#3085d6',
    cancelButtonColor: '#d33',
    confirmButtonText: 'Sí, eliminar!',
    cancelButtonText: 'No'
  }).then(result => {
    if (result.isConfirmed) {
      axios
        .delete(deleteRoute)
        .then(function (response) {
          Swal.fire('Eliminado!', 'Ha sido eliminado correctamente.', 'success').then(() => {
            window.location.href = redirectRoute
          })
        })
        .catch(function (error) {
          let errorMessage = 'Algo ha ido mal. Por favor, inténtelo de nuevo'

          if (error.response && error.response.data && error.response.data.message) {
            errorMessage = error.response.data.message
          }

          Swal.fire('Error!', errorMessage, 'error')
          console.error(error)
        })
    }
  })
}

// Vuelve a poner como contraseña el número de documento (usuarios y médicos).
window.resetPassword = function (url, name) {
  const safeName = $('<div>').text(name).html()
  Swal.fire({
    title: 'Reiniciar contraseña',
    html: `La contraseña de <strong>${safeName}</strong> volverá a ser su número de documento.`,
    icon: 'warning',
    showCancelButton: true,
    confirmButtonText: 'Reiniciar',
    cancelButtonText: 'Cancelar'
  }).then(result => {
    if (!result.isConfirmed) return
    axios
      .post(url)
      .then(response => Swal.fire({ icon: 'success', title: 'Contraseña reiniciada', html: response.data.message }))
      .catch(error =>
        Swal.fire({ icon: 'error', title: 'No se pudo reiniciar', text: error.response?.data?.message || '' })
      )
  })
}

window.toggleActive = function (button) {
  const url = button.getAttribute('data-url')
  const redirectUrl = button.getAttribute('data-redirect')
  const isActive = button.getAttribute('data-active') === '1'

  const action = isActive ? 'desactivar' : 'activar'
  const actionCapitalized = isActive ? 'Desactivar' : 'Activar'
  const confirmButtonColor = isActive ? '#d33' : '#28a745'

  Swal.fire({
    title: `¿${actionCapitalized}?`,
    text: `¿Desea ${action} este registro?`,
    icon: 'question',
    showCancelButton: true,
    confirmButtonColor: confirmButtonColor,
    cancelButtonColor: '#6c757d',
    confirmButtonText: `Sí, ${action}!`,
    cancelButtonText: 'Cancelar'
  }).then(result => {
    if (result.isConfirmed) {
      axios
        .post(url)
        .then(function (response) {
          Swal.fire('Actualizado!', response.data.message, 'success').then(() => {
            window.location.href = redirectUrl
          })
        })
        .catch(function (error) {
          let errorMessage = 'Algo ha ido mal. Por favor, inténtelo de nuevo'

          if (error.response && error.response.data && error.response.data.message) {
            errorMessage = error.response.data.message
          }

          Swal.fire('Error!', errorMessage, 'error')
          console.error(error)
        })
    }
  })
}

window.showLoader = function () {
  $('#loader-overlay').show()
}

window.hideLoader = function () {
  $('#loader-overlay').hide()
}

window.getCurrentPage = function () {
  const urlParams = new URLSearchParams(window.location.search)
  return urlParams.get('page') || 1
}

function validateTwoDigitDecimalNumber(event) {
  const regex = /^[+-]?\d*\.?\d{0,2}$/g
  const specialKeys = ['Backspace', 'Tab', 'End', 'Home', 'ArrowLeft', 'ArrowRight', 'Del', 'Delete']

  if (specialKeys.indexOf(event.key) !== -1) {
    return
  }

  const current = event.target.value
  const position = event.target.selectionStart
  const next = [current.slice(0, position), event.key === 'Decimal' ? '.' : event.key, current.slice(position)].join('')

  if (next && !String(next).match(regex)) {
    event.preventDefault()
  }
}

// Select2 4.0 does not focus its search box when opened with jQuery >= 3.6, so every select2 in the app gets it here.
$(document).on('select2:open', function (e) {
  const search =
    document.querySelector(`.select2-search__field[aria-controls="select2-${e.target.id}-results"]`) ||
    document.querySelector('.select2-container--open .select2-search__field')

  if (search) {
    setTimeout(() => search.focus(), 0)
  }
})
